import { Box } from '@machobear/design-system'
import playIcon from './play.svg'
import cubeIcon from './cube.svg'

const ICON_SIZE = 24

interface BaseProps {
  videoType: '2d' | '3d'
  handleClickThumbnail: () => void
}

type Props =
  | (BaseProps & { thumbnail: string | null; children?: never })
  | (BaseProps & { children: React.ReactNode; thumbnail?: never })

const VideoThumbnail = ({ videoType, thumbnail, handleClickThumbnail, children }: Props) => {
  const is3D = videoType === '3d'
  const label = is3D ? 'View 3D tour' : 'Play video'
  const iconSrc = is3D ? cubeIcon : playIcon

  return (
    <Box
      borderRadius="small"
      overflow="hidden"
      position="relative"
      background="neutral"
      cursor="pointer"
      role="button"
      aria-label={label}
      style={{
        width: 65,
        height: 50,
        flexShrink: 0,
        ...(thumbnail && {
          backgroundSize: 'cover',
          backgroundImage: `url(${thumbnail})`
        })
      }}
      onClick={e => {
        handleClickThumbnail()
        e.stopPropagation()
      }}
    >
      {children}
      <Box
        position="absolute"
        style={{
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.2)'
        }}
      />
      <Box
        position="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translateX(-50%) translateY(-50%)',
          borderRadius: '50%',
          width: ICON_SIZE,
          height: ICON_SIZE
        }}
      >
        <img src={iconSrc} alt="" width={ICON_SIZE} height={ICON_SIZE} />
      </Box>
    </Box>
  )
}

export default VideoThumbnail
